import {SuccessfulApiResponse} from "../generalResponses/SuccessfulApiResponse";
import {Currency} from "buenLib/domain/Currency";

export class GetDepositLimitsStatusSuccessfulResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        let emptyCurrencyObject = {};
        for (let currency of Currency.all()) {
            emptyCurrencyObject[currency] = "0"
        }
        return {
            "object": {
                "datetime": "2020-06-29T11:56:07.519253-03:00",
                "entries": [{
                    "name": "Sueldo Alto",
                    "amount": "700000.00000000",
                    "consumed": "600000.00000000000000000",
                    "available": "100000.00000000000000000",
                    "is_one_time": false,
                    "is_default": false,
                    "frequency": 1,
                    "interval": 1,
                    "by_month_day": null,
                    "start_datetime": "2020-06-01T00:00:00Z",
                    "until_datetime": "2021-06-01T00:00:00Z",
                    "created_at": "2020-06-22T14:14:40.584826Z",
                    "updated_at": "2020-06-25T20:25:17.692637Z"
                }, {
                    "name": "UIF Mensual",
                    "amount": "200000.00000000",
                    "consumed": "0",
                    "available": "200000.00000000",
                    "is_one_time": false,
                    "is_default": true,
                    "frequency": 1,
                    "interval": 1,
                    "by_month_day": null,
                    "start_datetime": "2020-06-01T00:00:00Z",
                    "until_datetime": null,
                    "created_at": "2020-06-22T13:21:29.631519Z",
                    "updated_at": "2020-06-22T13:22:27.465600Z"
                }, {
                    "name": "UIF Anual",
                    "amount": "400000.00000000",
                    "consumed": "0",
                    "available": "400000.00000000",
                    "is_one_time": false,
                    "is_default": true,
                    "frequency": 0,
                    "interval": 1,
                    "by_month_day": null,
                    "start_datetime": "2020-01-01T00:00:00Z",
                    "until_datetime": null,
                    "created_at": "2020-06-22T13:23:50.695066Z",
                    "updated_at": "2020-06-22T13:23:50.695102Z"
                }],
                "total_available": "100000.0",
                "is_available_close_to_run_out": "false",
                "total_amount_for_recurrent_limits": "200000",
                "total_amount_for_one_time_limits": "0",
                "total_available_by_currency": {
                    "ars": "100000.0",
                    "usd": "1000.0",
                    "dai": "833.3333333333333333333333333",
                    "btc": "0.1"
                },
                "total_amount_for_recurrent_limits_by_currency": {
                    "ars": "200000",
                    "usd": "2000",
                    "dai": "1666.666666666666666666666667",
                    "btc": "0.2"
                },
                "total_amount_for_one_time_limits_by_currency": {"ars": "0", "usd": "0", "dai": "0", "btc": "0"}
            }, "errors": []
        }
    }

    static noAvailableInAllCurrenciesResponse() {
        let emptyCurrencyObject = {};
        for (let currency of Currency.all()) {
            emptyCurrencyObject[currency] = "0"
        }
        return {
            "object": {
                "datetime": "2020-06-29T11:02:39.358638-03:00",
                "entries": [{
                    "name": "UIF Mensual",
                    "amount": "200000.00000000",
                    "consumed": "200000.00000000",
                    "available": "0",
                    "is_one_time": false,
                    "is_default": true,
                    "frequency": 1,
                    "interval": 1,
                    "by_month_day": null,
                    "start_datetime": "2020-01-01T00:00:00Z",
                    "until_datetime": null,
                    "created_at": "2020-01-01T00:00:00Z",
                    "updated_at": "2020-01-01T00:00:00Z"
                }, {
                    "name": "UIF Anual",
                    "amount": "400000.00000000",
                    "consumed": "400000.00000000",
                    "available": "0.00000000",
                    "is_one_time": false,
                    "is_default": true,
                    "frequency": 0,
                    "interval": 1,
                    "by_month_day": null,
                    "start_datetime": "2020-01-01T00:00:00Z",
                    "until_datetime": null,
                    "created_at": "2020-01-01T00:00:00Z",
                    "updated_at": "2020-01-01T00:00:00Z"
                }],
                "total_available": "0",
                "is_available_close_to_run_out": "true",
                "total_amount_for_recurrent_limits": "0",
                "total_amount_for_one_time_limits": "0",
                "total_available_by_currency": emptyCurrencyObject,
                "total_amount_for_recurrent_limits_by_currency": emptyCurrencyObject,
                "total_amount_for_one_time_limits_by_currency": emptyCurrencyObject
            }, "errors": []
        }
    }

    depositLimitsStatus() {
        return this.content();
    }
}